module.exports = {
  '': { value: '', code: 'N' },
  'foil': { value: 'common.foil', code: 'F' },
  'epee': { value: 'common.epee', code: 'E' },
  'saber': { value: 'common.sabre', code: 'S' },
  'sabre': { value: 'common.sabre', code: 'S' }
}
